<template>
  <div class="match-cost-detail">
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTab">
      <el-tab-pane
        v-for="v in tabs"
        :label="v.label"
        :name="v.value"
        :key="v.value"
      ></el-tab-pane>
    </el-tabs>
    <el-button
      type="primary"
      size="mini"
      style="margin-bottom: 10px"
      @click="handleReportDesign"
      >{{ currentTab.btnLable }}</el-button
    >
    <div class="table">
      <SimpleTable
        :show-index="true"
        ref="matchCostDetail"
        table-code="matchCostDetail"
        :bottomFrozenRowCount="currentTab.bottomFrozenRowCount"
        :columns="currentTab.columns || []"
        :data="currentTab.tableData"
      />
    </div>

    <ReportDesign :type="currentTab.type" ref="reportDesignRef" />
    <ReportView ref="reportViewRef" />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords } from '@/utils/index'
import { fbfx, fyhz, csxm, rcj, zjzb, qd, qyde } from '../HistoryData/column'
import ReportDesign from './ReportDesign.vue'
import ReportView from './ReportView.vue'

qyde.forEach(e => (e.canModify = false))

export default {
  name: 'MatchCostDetail',
  components: { SimpleTable, ReportDesign, ReportView },
  props: {
    getHistoryData: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      // 页面数据

      loading: false,
      tableData: [],
      currentTab: {},
      activeTab: 'gclqd',

      tabs: [
        {
          label: '工程量清单',
          value: 'gclqd',
          columns: qd,
          tableData: [],
          btnLable: '清单报表设计',
          type: 2,
          bottomFrozenRowCount: 1,
          tableCode: 'MatchCostDetail_gclqd',
          url: '/history-data-budget/bill/list'
        },
        {
          label: '人材机汇总',
          value: 'rcjhz',
          columns: qyde,
          tableData: [],
          btnLable: '人材机报表设计',
          type: 3,
          bottomFrozenRowCount: 1,
          tableCode: 'MatchCostDetail_rcjhz',
          url: '/history-data-budget/resource-summary/list'
        },
        {
          label: '概算指标',
          value: 'gszb',
          columns: zjzb,
          tableData: [],
          btnLable: '指标报表设计',
          type: 4,
          bottomFrozenRowCount: 1,
          tableCode: 'MatchCostDetail_gszb',
          url: '/history-data-budget/indicator/list'
        }
      ]
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.handleTab()
    },
    handleTab() {
      this.currentTab = this.tabs.find(e => e.value === this.activeTab)
      this.getData()
    },
    handleReportDesign() {
      const data = this.getHistoryData()

      if (!data.some(e => e.check)) {
        this.$message.warning('请先选中单项工程数据！')
        return
      }
      this.$refs.reportDesignRef.show({ reportView: this.reportView })
    },

    async getData(row) {
      if (row) this.topRow = row
      if (!this.topRow?.id) return
      const res = await this.$service.get(this.currentTab.url, {
        budgetId: this.topRow.id
      })
      this.currentTab.tableData = sortRecords(res?.data || [])
    },
    async reportView(row) {
      this.$refs.reportViewRef.show({
        projectId: this.projectId,
        row,
        getData: () => this.getReportData(row)
      })
    },

    async getReportData(row) {
      const data = this.getHistoryData()
      const res = await this.$service.post('/report/generateHistoryReport', {
        costAnalyzeSettingId: row.id,
        ids: data.filter(e => e.check).map(e => e.id)
      })
      return res
    }
  }
}
</script>

<style scoped lang="less">
.match-cost-detail {
  height: 400px;
  .table {
    height: calc(100% - 72px);
  }
}
</style>
